import { Resizable } from 're-resizable';
import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FileContext } from '../../../context/FileContext';
import RequiredIcon from '../../../assets/icons/astrik.svg';
import { useTranslation } from 'react-i18next';
import { useColumnOrder } from '../../../hooks/useColumnOrder';
import { DEFAULT_HEIGHTS } from '../../../constants/pdfOverlayDimensions';

const Icon = styled.img``;

const OuterContainer = styled.div`
  border: 1px solid transparent !important;
  border-radius: 4px !important;
  padding: ${({ noPadding }) => (noPadding ? '0' : '2px')};
  &.active {
    border: 1px solid #0073EA !important;
    border-radius: 4px !important;
  }

  &.hover-active:hover {
    border: 1px solid #0073EA !important;
    border-radius: 4px !important;
  }

  .resizable-min-dimensions {
    min-height: ${({ fontSize }) =>
      fontSize + 4 + 'px'}; //padding 2px on all sides
  }
`;

const TextInputContainer = styled.div`
  font-size: ${({ fontSize }) => fontSize + 'px'};
  line-height: ${({ fontSize }) => fontSize + 'px'};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border: 1px solid ##0073EA !important;
  border-radius: 4px !important;
  width: 100%;
  height: 100%;
  background: ${({ color }) => (color ? color : 'white')};
  color: black;
  overflow: hidden;
  border: 1px solid #c5c7d0;
  border-radius: 4px;
`;

const TextBoxText = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ fontSize }) => fontSize + 'px'};
`;

const TextBoxEditOverlayChip = ({ item, setIsResizing }) => {
  // height of container for text box on initialization
  const defaultHeight = DEFAULT_HEIGHTS.TEXT_BOX;
  const defaultWidth = 150;
  const fontSize = item.fontSize || 11;

  const { t } = useTranslation();

  const {
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
    draggableFieldsData,
  } = useContext(FileContext);

  const { mapColor } = useColumnOrder();
  const itemColor = item.color ?? item.signer?.color;
  const backgroundColor = itemColor
    ? mapColor(itemColor)
    : '#E6E6FA';

  useEffect(() => {
    if (!item?.width) item.width = defaultWidth;
    if (!item?.height) item.height = defaultHeight;
  }, []);

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, ref, d) => {
    setIsResizing(false);

    // Get the exact size from the Resizable component's current state
    const size = ref.style;
    // get bounding rect to get the exact size of the text box
    const boundingRect = ref.getBoundingClientRect();
    const height = parseFloat(size.height) || boundingRect.height;
    const width = parseFloat(size.width) || boundingRect.width;
    item.width = width;
    item.height = height;

    addedFormFields[currentSelectedItem.current] = item;
    draggableFieldsData[item.itemId] = {
      height: item.height,
      width: item.width,
    };
    updateFormFields([...addedFormFields]);
  };
  const noPadding = item.noPadding || false;
  return (
    <>
      <OuterContainer
        fontSize={fontSize}
        className={item.isActive ? 'active' : 'hover-active'}
        noPadding={noPadding}
      >
        <Resizable
          size={{
            height: item?.height || defaultHeight,
            width: item?.width || defaultWidth,
          }}
          // minHeight={fontSize + 4}
          lockAspectRatio={false}
          enable={{
            top: false,
            right: item?.isActive,
            bottom: item?.isActive,
            left: false,
            topRight: false,
            bottomRight: item?.isActive,
            bottomLeft: false,
            topLeft: false,
          }}
          className={
            item.isActive
              ? 'resizeable resizable-min-dimensions'
              : noPadding === false
              ? 'resizable-min-dimensions'
              : ''
          }
          onResizeStart={handleResizeStart}
          onResizeStop={handleResizeEnd(item)}
        >
          <TextInputContainer fontSize={fontSize} color={backgroundColor}>
            {/* <TextBoxText className='text-box-text'>{t('Placeholder text here')}</TextBoxText>
            {item.required ? (
              <Icon
                src={RequiredIcon}
                alt=""
                height={fontSize * 0.7}
                width={fontSize * 0.7}
              />
            ) : null} */}
          </TextInputContainer>
        </Resizable>
      </OuterContainer>
    </>
  );
};

export default TextBoxEditOverlayChip;
